
import React from 'react';

const PayPalButton = () => {
    return (
        
        <a href="https://paypal.me/appDevRamendra?country.x=IN&locale.x=en_GB" target="_blank" rel="noopener noreferrer">
            <img src={require('./paypal.jpeg')} alt="Paypal Link" style={{ height: '80px', width: '250px' }}  /></a>
    );
};



export default PayPalButton;

